import { render, staticRenderFns } from "./AppVendor.vue?vue&type=template&id=fe4fd596&"
import script from "./AppVendor.vue?vue&type=script&lang=js&"
export * from "./AppVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports